import { render, staticRenderFns } from "./SlotsPreview.vue?vue&type=template&id=7c9b4d2e&scoped=true&"
import script from "./SlotsPreview.vue?vue&type=script&lang=ts&"
export * from "./SlotsPreview.vue?vue&type=script&lang=ts&"
import style0 from "./SlotsPreview.vue?vue&type=style&index=0&id=7c9b4d2e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c9b4d2e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VFlex,VIcon,VLayout})
